import type { ReactNode } from 'react'

import { Link } from '@b-stock/fe-core/bstock-react'
import type {
  DocumentDto,
  DocumentDtoDocTypeEnum,
} from '@b-stock/listing-api-client'

type DocumentLinkProps = {
  documents?: DocumentDto[]
  documentType: DocumentDtoDocTypeEnum
  children?: ReactNode
}

export const DocumentLink = ({
  documents,
  documentType,
  children,
}: DocumentLinkProps) => {
  const doc = documents?.find(({ docType }) => docType === documentType)

  if (!doc?.url) return <>{children}</>

  return (
    <Link target="_blank" href={doc.url}>
      {children}
    </Link>
  )
}
